<script lang="ts">
  import { dispatchConfetti } from '../util/confetti';
  import { press } from '../util/press';
  import { trackEvent } from '../util/snowplow';
  import { showWebGlAnimations } from './Confetti/usewebglStore';

  // export let celebrateName = 'MGP';

  let frameCount = 0;
  const maxFrames = 100;
  let throttleTimeoutId: number | undefined;

  const fireConfetti = (count: number, secondsPressed: number) => {
    const numberOfParticles = count < 10 ? count : count * 3;
    dispatchConfetti(Math.min(numberOfParticles, 1500));
    const msToVibrate = Math.min(numberOfParticles, 2000);
    try {
      navigator.vibrate(msToVibrate);
    } catch (_error) {
      // trackEvent({ action: 'error:confetti-vibration' });
    }
    debounceTrackConfetti(secondsPressed);

    // const numberOfThanks = Math.ceil(frameCount / 60);
    // ariaLiveService.send('readAriaLive', {
    //   data:
    //     numberOfThanks < 2
    //       ? `Hurra for ${celebrateName}!`
    //       : `${numberOfThanks} ganger hurra for ${celebrateName}! ${'HURRA! '.repeat(
    //           numberOfThanks
    //         )}`,
    // });

    frameCount = 0;
  };

  const debounceTrackConfetti = (() => {
    let count = 0;
    let maxSecondsPressed = 0;
    return (secondsPressed: number) => {
      count++;
      maxSecondsPressed = Math.max(secondsPressed, maxSecondsPressed);

      if (throttleTimeoutId != undefined) {
        return;
      }

      throttleTimeoutId = window.setTimeout(() => {
        trackConfetti(maxSecondsPressed, count);
        count = 0;
        maxSecondsPressed = 0;
        throttleTimeoutId = undefined;
      }, 3000);
    };
  })();

  const trackConfetti = (secondsPressed: number, numberOfClicks: number) => {
    trackEvent({
      action: 'click:more-confetti',
      label: `times-${numberOfClicks}-${secondsPressed}`,
    });
  };

  $: loadScale = frameCount > 100 ? 1 : frameCount / maxFrames;
  $: vibrationVibes = frameCount / maxFrames;
</script>

{#if $showWebGlAnimations}
  <button
    class="confetti-button"
    class:vibrate={frameCount > maxFrames}
    style="--load-scale: {loadScale}; --vibration-vibes: {vibrationVibes}"
    on:dblclick|preventDefault
    use:press
    on:press={(event) => {
      frameCount = event.detail.count;
    }}
    on:release={(event) => {
      fireConfetti(event.detail.count, event.detail.secondsPressed);
    }}
    title="Trykk og hold for å få mer konfetti"
  >
    <span class="confetti-button-background" aria-hidden="true" />
    <span class="text">mer konfetti!</span>
  </button>
{/if}

<style>
  .confetti-button {
    touch-action: manipulation;
    background-color: rgba(0, 0, 0, 0.6);
    margin-bottom: 1rem;
    height: 4rem;
    width: 100%;
    max-width: 28rem;
    position: relative;
    -webkit-tap-highlight-color: transparent;
    box-shadow: 0px 0px 17px #ffcd14;
    border-image-source: linear-gradient(
      90deg,
      #683b10 0%,
      #8e6807 19.79%,
      #bb9725 42.71%,
      #e1b828 88.02%
    );
    transform: translateZ(0);
  }

  .text {
    color: #ffcd14;
    mix-blend-mode: difference;
    /* text-shadow: 0px 0px 2px #ffcd14; */
  }

  .confetti-button-background {
    display: block;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    transition: transform 150ms cubic-bezier(0.075, 0.82, 0.165, 1);
    background: linear-gradient(
      90deg,
      #683b10 0%,
      #8e6807 9.79%,
      #bb9725 22.71%,
      #e1b828 100%
    );
    transform: scaleX(max(var(--load-scale), 0.02));
    transform-origin: 0;
  }

  .vibrate {
    animation: vibrate 125ms ease-in-out infinite;
    --negative-deg: calc(-1deg * (var(--vibration-vibes) / 2));
    --positive-deg: calc(1deg * (var(--vibration-vibes) / 2));
  }

  @keyframes vibrate {
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(var(--positive-deg));
    }
    50% {
      transform: rotate(0deg);
    }
    75% {
      transform: rotate(var(--negative-deg));
    }
    100% {
      transform: rotate(0deg);
    }
  }
</style>
